import { type ReactElement } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { usePermissionCheck, useProfile, useTranslation } from '@front/model'
import { Page, TAlert } from '@components'
import { FlaggedQueue } from './FlaggedQueue'

export function FlaggedConversations(): ReactElement {
  const { company } = useProfile()
  const { t } = useTranslation()
  const permission = usePermissionCheck({ permissionType: 'conversation:manage', targetId: company?.companyId })
  if (permission.isSuccess && permission.data === true && !permission.isFetching) return <FlaggedQueue />
  return (
    <Page>
      <Page.Heading title={t('Flagged conversations')} back />
      <Page.Content>
        <TAlert variant={permission.isLoading ? 'default' : 'warning'}>
          {permission.isLoading
            ? t('Checking permission…')
            : t('Company-level conversation management permission is required.')}
        </TAlert>
      </Page.Content>
    </Page>
  )
}

export const Route = createFileRoute('/conversations_/flagged/')({ component: FlaggedConversations })
